import Vue from 'vue';
Vue.directive('focus', {
    inserted: (el) => {
        el.focus();
    },
    update: (el) => {
        Vue.nextTick(() => {
            el.focus();
        });
    }
});